import { Pipe, PipeTransform } from '@angular/core';
import { RealisationHourtype } from '../classes/realisation';
import { RealisationService } from '../services/realisation.service';

@Pipe({
    name: 'hourtypeIcon',
    standalone: true,
})
export class HourtypeIconPipe implements PipeTransform {
    transform(type: RealisationHourtype) {
        return RealisationService.hourtypeIconNames.get(type) ?? 'fa-question';
    }
}
